import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Collapse,
  Link,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import PolicyIcon from "@mui/icons-material/Policy";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import SafetyCheckIcon from "@mui/icons-material/SafetyCheck";
import Diversity3Icon from '@mui/icons-material/Diversity3';

const Consultas = () => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <List
      sx={{
        width: "100%",
        maxWidth: 360,
        bgcolor: "#212529",
        color: "white",
        margin: 0,
        padding: 0,
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>
          <PolicyIcon style={{ color: "white" }} />
        </ListItemIcon>
        <ListItemText primary="Consultas" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <HealthAndSafetyIcon style={{ color: "white" }} />
            </ListItemIcon>

            <Link
              color="inherit"
              style={{ textDecoration: "none" }}
              href="/consultaut"
            >
              <ListItemText primary="Consultar Aut" />
            </Link>
          </ListItemButton>

          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <SafetyCheckIcon style={{ color: "white" }} />
            </ListItemIcon>

            <Link
              color="inherit"
              style={{ textDecoration: "none" }}
              href="/consultdata"
            >
              <ListItemText primary="Consultas por fecha" />
            </Link>
          </ListItemButton>

          <ListItemButton sx={{ pl: 4 }}>
            <ListItemIcon>
              <Diversity3Icon style={{ color: "white" }} />
            </ListItemIcon>

            <Link
              color="inherit"
              style={{ textDecoration: "none" }}
              href="/nucleofamiliar"
            >
              <ListItemText primary="Consultar Nucleo" />
            </Link>
          </ListItemButton>
        </List>
      </Collapse>
    </List>
  );
};

export default Consultas;
